export function Logo({ compact = false }) {
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" aria-hidden="true">
        <rect width="34" height="34" rx="9" fill="#0D1726" stroke="#1E3045" />
        <path d="M7 25L14 15L19 20L27 9" stroke="#22C55E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="27" cy="9" r="3" fill="#38BDF8" />
      </svg>
      {!compact && (
        <span className="font-jakarta font-extrabold text-lg tracking-tight text-rw-text">
          RAVI<span className="text-rw-green">WORKS</span>
        </span>
      )}
    </span>
  );
}
